// extracted by mini-css-extract-plugin
export default {"shareTo__title":"style_shareTo__title__ozE+g","shareTo__listIcons":"style_shareTo__listIcons__jJRfx","shareTo__iconsContainer":"style_shareTo__iconsContainer__kii0C"};